import { z } from "zod";

export namespace BillApi {
  export const billSchema = z.object({
    id: z.number(),
    error: z.string().nullable(),
    retryCount: z.number(),
    status: z.enum(["pending", "processing", "succeeded", "failed", "canceled"]),
    billingDate: z.string().datetime().nullable(),
    willAutoRetry: z.boolean(),
  });

  export type Bill = z.infer<typeof billSchema>;
}
